import { formatTime, formatWeekdayDate } from 'utils/datetime';

/**
 * Compose the "<date> · <time>" label used in the DetailsHeader for the
 * ride departure. Both formatters are timezone-aware; the caller passes
 * the first station's IANA zone.
 *
 * @param {string | null | undefined} departure UTC ISO
 * @param {string | undefined} firstStationTimezone IANA zone
 * @returns {string}
 */
export const buildDepartureLabel = (departure, firstStationTimezone) => {
	if (!departure) return '';
	const date = formatWeekdayDate(departure, firstStationTimezone);
	const time = formatTime(departure, {
		timezone: firstStationTimezone,
		showTimezone: true,
	});
	return `${date} · ${time}`;
};
